// hooks/useResumeViewer.ts
import { useState } from "react";

interface UseResumeViewerReturn {
  isModalOpen: boolean;
  currentResumeUrl: string;
  currentApplicantName: string;
  openResume: (resumeUrl: string, applicantName?: string) => void;
  closeResume: () => void;
}

export const useResumeViewer = (): UseResumeViewerReturn => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentResumeUrl, setCurrentResumeUrl] = useState("");
  const [currentApplicantName, setCurrentApplicantName] = useState("");

  const openResume = (
    resumeUrl: string,
    applicantName: string = "Applicant",
  ) => {
    let processedUrl = resumeUrl;

    // For Cloudinary PDFs, ensure they're accessible
    if (resumeUrl.includes("cloudinary.com")) {
      // KEEP raw upload URLs as-is for PDFs - don't convert to image upload!
      if (resumeUrl.includes("/raw/upload/")) {
        processedUrl = resumeUrl; // Keep the original raw URL
      }
      // If it's already an image upload URL, use it directly
      else if (resumeUrl.includes("/image/upload/")) {
        processedUrl = resumeUrl;
      }
      // Alternative: Extract public ID and construct delivery URL
      else {
        const urlParts = resumeUrl.split("/");
        const publicId = urlParts[urlParts.length - 1];
        processedUrl = `https://res.cloudinary.com/dlhf18bx8/raw/upload/${publicId}`;
      }

      // Ensure PDF extension for proper browser handling
      if (processedUrl.includes(".pdf") && !processedUrl.endsWith(".pdf")) {
        processedUrl += ".pdf";
      }
    }

    // If it's a relative URL, convert to absolute
    if (resumeUrl.startsWith("/uploads/")) {
      processedUrl = `${window.location.origin}${resumeUrl}`;
    }

    console.log("Opening resume:", {
      original: resumeUrl,
      processed: processedUrl,
    });

    setCurrentResumeUrl(processedUrl);
    setCurrentApplicantName(applicantName);
    setIsModalOpen(true);
  };

  const closeResume = () => {
    setIsModalOpen(false);
    setCurrentResumeUrl("");
    setCurrentApplicantName("");
  };

  return {
    isModalOpen,
    currentResumeUrl,
    currentApplicantName,
    openResume,
    closeResume,
  };
};
